import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Automation } from "../_types/automation";
@Injectable({
    providedIn: 'root',
})

export class AutomationsService extends Service<Automation> {
  public override type = 'automations';
  public override url = 'common/automations'; 
}
